import React, { Component } from 'react';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import { Alert, Button, Modal } from 'elements';

import validate from './validate';
import { connect } from 'react-redux';

import './index.css';

import { wsClient } from '../../index';
import { PageContent, TextField } from '../../components';
import RedSwitch from '@/assets/images/red-switch.png';

class MfaSettingsForm extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isMFAEnabled: false,
			isOpen: false,
			user: {},
			qrUrl: null,
			totpCode: null,
		};

		this.toggleMFAStatus = this.toggleMFAStatus.bind(this);
		this.setMFAState = this.setMFAState.bind(this);
		this.setTOTPCode = this.setTOTPCode.bind(this);
	}

	componentDidMount() {
		this.setInitialState();
	}

	showQRCode = () => {
		const requestPayload = {
			messageType: 'core.operator.qr-code',
			payload: {
				clientId: this.state.user.clientId,
				username: this.state.user.username,
			},
		};

		let that = this;

		wsClient.request(requestPayload, response => {
			that.setState(
				{
					qrUrl: response.payload,
				},
				function() {},
			);
		});
	};

	setInitialState() {
		let { user } = this.props;

		if (user) {
			let { currentUser } = user;
			let { operator } = currentUser;

			this.setMFAState(operator.isMFAEnabledByOperator);
			this.setState(
				{
					user: operator,
				},
				function() {},
			);
		}
	}

	setMFAState(newValue) {
		this.setState(
			{
				isMFAEnabled: newValue,
			},
			function() {},
		);

		if (!newValue) {
			this.setState(
				{
					qrUrl: null,
				},
				function() {},
			);
		}
	}

	toggleMFAStatus(event) {
		let target = event.currentTarget;

		if (target.checked) {
			this.showConfirmationModal();
		} else {
			this.showDisableModal();
		}

		this.setMFAState(target.checked);
	}

	showConfirmationModal = () => {
		let that = this;

		Modal.confirm({
			title: 'Enable 2FA',
			icon: 'exclamation-circle',
			content: 'Do you wish to continue?',
			onOk: () => {
				that.showQRCode();
				return Promise.resolve();
			},
			onCancel() {
				that.setMFAState(false);
			},
		});
	};

	showDisableModal = () => {
		let that = this;

		Modal.confirm({
			title: 'Disable 2FA',
			icon: 'exclamation-circle',
			content: 'Do you wish to continue?',
			onOk: () => {
				that.deActivateMFA();
				that.setMFAState(false);
			},
			onCancel() {
				that.setMFAState(true);
			},
		});
	};

	showCompletionModal = () => {
		Modal.success({
			title: 'Congratulations!',
			icon: 'info-circle',
			content: 'You have successfully enabled 2FA on your account.',
		});
	};

	showCompletionDisabledModal = () => {
		Modal.success({
			title: '2FA Disabled',
			icon: 'info-circle',
			content: 'You have successfully disabled 2FA on your account.',
		});
	};

	setTOTPCode(event) {
		let target = event.currentTarget;

		this.setState(
			{
				totpCode: target.value,
			},
			function() {},
		);
	}

	activateMFA = () => {
		const requestPayload = {
			messageType: 'core.operator.activate-mfa',
			payload: {
				clientId: this.state.user.clientId,
				username: this.state.user.username,
				totp: this.state.totpCode,
			},
		};

		let that = this;

		wsClient.request(requestPayload, response => {
			console.log(response);

			switch (response.messageType) {
				case 'core.error.invalid-totp':
					alert('Invalid TOTP code. Please, try again');
					break;
				case 'core.operator.activate-mfa-result':
					let user = that.state.user;
					user.isMFAEnabledByOperator = true;

					that.setState(
						{
							user: user,
							qrUrl: null,
						},
						function() {},
					);

					this.showCompletionModal();
			}
		});
	};

	deActivateMFA = () => {
		const requestPayload = {
			messageType: 'core.operator.de-activate-mfa',
			payload: {
				clientId: this.state.user.clientId,
				username: this.state.user.username
			},
		};
		let that = this;
		wsClient.request(requestPayload, response => {
			console.log(response);

			switch (response.messageType) {
				case 'core.operator.de-activate-mfa-result':
					let user = that.state.user;
					user.isMFAEnabledByOperator = false;
					that.setState(
						{
							user: user,
							qrUrl: null,
						},
						function() {},
					);
					this.showCompletionDisabledModal();
			}
		});
	};

	render() {
		const { error } = this.props;
		return (
			<PageContent.Main>
				<div>
					<form>
						{!this.state.user.isMFAEnabledByOperator && (
							<div>
								<Alert
									message="You haven't configured two-factor authentication."
									type="warning"
								/>
								<div className="mt-15 justify">
									In order to proceed, you need a secure app
									on your smartphone to generate login codes.
									We recommend using{' '}
									<a
										href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_UK&gl=UK"
										target="_blank"
									>
										Google Authenticator
									</a>
									, but you can use any other.
									<div className="mt-15">
										Please, turn on the red switch below (
										<img src={RedSwitch} alt="Switch" />
										).
									</div>
								</div>
							</div>
						)}
						{error && <Alert message={error} type="error" />}

						<div className="mt-15">
							Status:{' '}
							<b>
								{this.state.user.isMFAEnabledByOperator
									? 'Enabled'
									: 'Disabled'}
							</b>
						</div>
						<div className="toggle-pill-color">
							<input
								type="checkbox"
								id="pill3"
								disabled={
									this.state.user.isMFAEnabledByClient
								}
								name="mfaStatus"
								checked={this.state.isMFAEnabled}
								onChange={this.toggleMFAStatus}
							/>
							<label htmlFor="pill3"></label>
						</div>
						{this.state.qrUrl && (
							<div>
								<details open>
									<summary>
										<b className="text-md">Instructions</b>
									</summary>
									<ul
										style={{
											'listStyleType': 'square',
											'textAlign': 'justify',
										}}
									>
										<li>
											Open Google Authenticator on your
											mobile phone.
										</li>
										<li>
											Select the{' '}
											<b className="text-md">+</b>{' '}
											icon from the bottom right of the
											screen, and select{' '}
											<b>Scan a QR code</b>.
										</li>
										<li>
											Place the below QR code into the red
											lines on screen.
										</li>
										<li>
											The QR code will be scanned, and
											will be added to Google
											Authenticator, with the name
											"Unifi".
										</li>
										<li>
											Google Authenticator will start
											generating time-based codes for your
											newly added account. Wait until a
											new code appears on the screen, type
											it in the <b>OTP Code</b> text input
											and press <b>Validate TOTP</b>.
										</li>
										<li>
											If you enter a valid code, your
											account setup will be complete.
										</li>
									</ul>
								</details>

								<div className="mt-15">
									<img src={this.state.qrUrl} alt="QR Code" />
								</div>

								<div>
									<Field
										className="small"
										name="totp"
										label="OTP Code"
										htmlFor="totp"
										component={TextField}
										onChange={this.setTOTPCode}
									/>
									<Button
										type="primary"
										className="small"
										onClick={this.activateMFA}
									>
										Validate TOTP
									</Button>
								</div>
							</div>
						)}
					</form>
				</div>
			</PageContent.Main>
		);
	}
}

function mapStateToProps(state) {
	const { user } = state;
	return { user: user };
}

export default compose(
	withRouter,
	reduxForm({
		form: 'mfaSettings',
		validate,
	}),
	connect(mapStateToProps),
)(MfaSettingsForm);



// WEBPACK FOOTER //
// ./src/smart-components/mfa-settings-form/index.js